export const funProverbs: string[] = [
  "La curiosite fait grandir plus vite qu'une courgette au soleil.",
  "Un cartable range vaut deux heures gagnees.",
  "Qui partage ses crayons trouve toujours un ami.",
  "Le sourire est le meilleur taille-crayon du matin.",
  "On apprend autant en jouant qu'en comptant.",
  "Les devoirs sont plus legers apres un bon gouter.",
  "Chaque faute est une marche vers la reussite.",
  "Un livre ouvert fait voyager sans bus scolaire.",
  "Un merci ouvre plus de portes qu'une cle USB.",
  "La patience est le super pouvoir des grands eleves.",
  "Une idee partagee grandit comme une graine arrosees.",
  "Le courage est un muscle: on le travaille chaque jour.",
  "Un cahier soigne raconte de belles histoires.",
  "Mieux vaut poser une question que rester dans le brouillard.",
  "Les tables de multiplication aiment les chansons.",
  "Un cartable range rend la cloche moins pressante.",
  "Le respect tient plus chaud qu'un pull en hiver.",
  "Un bonjour ouvre la recre, un sourire la prolonge.",
  "La curiosite saute plus haut que la corde a sauter.",
  "On lit avec les yeux, on comprend avec le coeur.",
  "Un pas de plus, c'est une peur en moins.",
  "On retient mieux quand on rigole un peu.",
  "Qui trie ses feutres epargne son voisin.",
  "La recre est courte, l'amitie est longue.",
  "Un probleme partage est deja a moitie resolu.",
  "Une idee folle aujourd'hui sera une invention demain.",
  "Les bons mots sont des bonbons sans sucre.",
  "Un cahier brouillon est une salle d'entrainement.",
  "La cloche ne sonne jamais assez vite pour celui qui attend.",
  "La regle sert aussi a tracer des ponts.",
  "Les doigts pleins d'encre fabriquent des souvenirs.",
  "Un petit effort chaque jour vaut mieux qu'un grand sprint le dimanche.",
  "On peut courir apres un bus, pas apres le temps.",
  "Un bon carnet de correspondance dit merci.",
  "La calculette n'a pas d'humour, le prof si.",
  "Les stylos perdus reviennent dans les poches des copains.",
  "Un dessin explique ce que les mots ne trouvent pas.",
  "On lit les contes, on ecrit son histoire.",
  "Les gommes effacent, les erreurs enseignent.",
  "Une blague partagee vaut une redaction inspiree.",
  "Le tableau blanc aime les idees colorees.",
  "Un sac trop lourd se porte a deux.",
  "Un bon plan de travail vaut un tresor cache.",
  "La curiosite ne prend jamais de vacances.",
  "Un petit pas d'orthographe, un grand pas pour la redac.",
  "On revise mieux en chantant qu'en soupirant.",
  "Une carte du monde est un billet d'avion en papier.",
  "Les maths sont des enigmes qui adorent etre resolues.",
  "Un probleme de maths est moins farouche avec un ami.",
  "Les parents sont des super-profs du soir.",
  "Les profs sont des super-guides du matin.",
  "Une colle de papier vaut mieux qu'une colle de retenue.",
  "Les cahiers aiment les autocollants de fierte.",
  "Un compliment donne des ailes sans plumes.",
  "Une pause d'eau fraiche rallume le cerveau.",
  "Un reve se revise comme une poesie.",
  "On trouve toujours une gomme, jamais deux compas.",
  "Les crayons courts ecrivent des grandes idees.",
  "Une feuille blanche n'a pas peur de la pluie d'idees.",
  "Les cartes de France adorent les voyages scolaires.",
  "Un bon agenda evite les surprises du lundi.",
  "Les copains sont des dictionnaires vivants.",
  "On partage les biscuits, pas les notes.",
  "Un nez qui renifle sent aussi les livres neufs.",
  "Le silence aide les idees a crier plus fort.",
  "La musique des stylos est une chanson d'ecole.",
  "Un soupir profond rallonge la recre.",
  "Les chaises grincent mais elles ecoutent.",
  "La colle blanche ne recolle pas les excuses.",
  "Un parapluie partage garde deux cartables au sec.",
  "Un tableau noir adore les craies blanches.",
  "Les regles droites adorent les esprits tordus.",
  "Un mot d'humour vaut un mot d'excuse.",
  "La poubelle de classe est le musee des brouillons.",
  "Un mot gentil dans le carnet fait sourire le directeur.",
  "Les poches de manteau sont des tunnels a stylos.",
  "Un cartable leger fait des pas plus joyeux.",
  "Les equations aiment la patience autant que les fleurs aiment l'eau.",
  "Les parents lisent les bulletins, les enfants ecrivent l'histoire.",
  "Une question en cours evite dix questions a la maison.",
  "Les pauses sont des vitamines pour le cerveau.",
  "Une dictée bien lue est a moitie ecrite.",
  "Les tables aiment les calculs, les eleves aiment les pauses.",
  "Un sourire au prof, c'est un bonus discret.",
  "Les trousses adorees ne perdent jamais leurs crayons.",
  "Les cahiers cornés racontent des aventures.",
  "Un copain timide connait de grandes reponses.",
  "Les cartes de geographie sont des invitations.",
  "Chaque lundi est une nouvelle page propre.",
  "Les baskets rapides arrivent a l'heure.",
  "Un cours de sciences est une chasse au tresor.",
  "La lecture du soir est la meilleure veilleuse.",
  "Les parents ont des super pouvoirs de signature.",
  "Un bonsoir aux cahiers ferme la journee.",
  "La cour de recre est un terrain d'apprentissage secret.",
  "Les feutres secs aiment les capuchons trouves.",
  "Un exposé commence par une idee un peu folle.",
  "Le cartable du vendredi adore etre vide.",
  "Les regles de grammaire sont des panneaux de signalisation.",
  "Les elevateurs d'ecole sont les escaliers.",
  "Un petit chocolat motive de grandes copies.",
  "Les lacets faits serrent aussi les idees.",
  "Un classeur organise calme les tornades de feuilles.",
  "Le courage commence par lever la main.",
  "Les reveils du matin sont plus doux avec un projet cool.",
];
